import { cx, api, rx } from "../../../../api";
import { ofType, combineEpics } from 'redux-observable';
import { switchMap, takeUntil, map as rxmap, filter, tap, ignoreElements } from 'rxjs/operators';
import { formatDateTime, getTimezoneString } from '../../../../misc/misc';
import { resolver } from './resolver';
import { actions } from '../actions';
import { fc, f } from "../../../../../i18n";
import { errorMap } from "../../../actions";

const requestEpic = (action$) => {
	return action$.pipe(
		ofType(actions.speeding.request.type),
		switchMap(action =>
			rx(api.reports.speeding, action.uri, action.parameters).pipe(
				rxmap(operation => actions.speeding.success({ intervals: operation.response() })),
				errorMap(actions.speeding.fail),
				takeUntil(action$.pipe(ofType(actions.speeding.cancel.type)))
			)
		)
	)
}

const startPrepareEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.speeding.export.type),
		rxmap(action => {
			const state = state$.value.reports.speeding;
			resolver.resolve(state.list, !state.hasMore);
			if (state.hasMore) {
				return actions.speeding.request({ uri: action.uri, parameters: state.parameters });
			} else {
				return actions.speeding.success({});
			}
		})
	)
}

const processPrepareEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.speeding.success.type),
		filter(action => {
			const state = state$.value.reports.speeding;
			if (state.exporting) resolver.resolve(action.intervals, !state.hasMore);
			return state.exporting && state.hasMore;
		}),
		rxmap(action => {
			const state = state$.value.reports.speeding;
			return actions.speeding.request({ uri: state.uri, parameters: state.parameters });
		})
	)
}

const exportCsvEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.speeding.exportProgress.type),
		filter(action => action.progress == 100),
		rxmap(action => {
			const state = state$.value.reports.speeding;
			const device = state$.value.devices.map[state.uri];
			// report header
			var csv = '"'
				+ fc('report type')
				+ '",'
				+ fc('generated')
				+ ','
				+ fc('timezone')
				+ ','
				+ fc('device')
				+ ','
				+ fc('since')
				+ ','
				+ fc('until')
				+ ',"'
				+ fc('speed threshold')
				+ '","'
				+ fc('minimum period')
				+ '"\n';
			csv += fc('speeding');  // report type
			csv += ',' + formatDateTime(cx.now()); // generated at
			csv += ',' + getTimezoneString(); // timezone at
			csv += ',"' + (device.denomination() || device.uri) + '"';
			csv += ',"' + formatDateTime(state.parameters.timeRange.since) + '"';
			csv += ',"' + formatDateTime(state.parameters.timeRange.until) + '"';
			csv += ',' + state.parameters.speedThreshold;
			csv += ',' + state.parameters.minPeriod;
			csv += "\n\n";
			// content header
			csv += fc('since')
				+ ',"'
				+ fc('since location')
				+ '","'
				+ fc('since address')
				+ '",'
				+ fc('until')
				+ ',"'
				+ fc('until location')
				+ '","'
				+ fc('until address')
				+ '","'
				+ fc('maximum speed') + ', ' + f('units.km/h')
				+ '"\n';
			// content
			state.list.forEach(interval => {
				// since
				const sinceMessage = interval.since;
				csv += '"' + formatDateTime(sinceMessage.generatedAt) + '"';
				csv += ',(' + sinceMessage.latitude + ';' + sinceMessage.longitude + ')';
				let entryKey = resolver.key(sinceMessage.latitude, sinceMessage.longitude);
				let address = resolver.resolved[entryKey]?.getAddress();
				if (address) csv += ',"' + address.format() + '"';
				else csv += ",-";
				// until
				const untilMessage = interval.until;
				csv += ',"' + formatDateTime(untilMessage.generatedAt) + '"';
				csv += ',(' + untilMessage.latitude + ';' + untilMessage.longitude + ')';
				entryKey = resolver.key(untilMessage.latitude, untilMessage.longitude);
				address = resolver.resolved[entryKey]?.getAddress();
				if (address) csv += ',"' + address.format() + '"';
				else csv += ",-";
				// speed
				csv += ',' + interval.maxSpeed;
				//
				csv += "\n";
			});
			return actions.speeding.exportDone({ csv });
		}),
	)
}

const exportClearEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.speeding.exportClear.type),
		tap(() => resolver.clear()),
		ignoreElements()
	);
}

const epic = combineEpics(requestEpic, startPrepareEpic, processPrepareEpic, exportCsvEpic, exportClearEpic);

export { epic };
